<div [formGroup]="fg">
    <div class="action-setting" *ngIf="withContactMaker">
        <div class="action-setting-info">
            <mat-checkbox
                color="primary"
                formControlName="contactMaker"
                [matTooltip]="warningNoRecipientsTooltip"
                matTooltipClass="long-text-tooltip-container">
                {{ "commonActions.sendEmailAction.contactMaker" | labelsProvider }}
            </mat-checkbox>
        </div>
    </div>
    <div class="action-setting">
        <div class="action-setting-title">
            {{ "commonActions.sendEmailAction.to" | labelsProvider }}
        </div>
        <input
            class="action-setting-input"
            formControlName="recipientsString"
            type="text"
            placeholder="Enter emails, separate with , or ;."
            [ngClass]="{
                'input-form-invalid':
                    fg.controls['recipientsString'].invalid && (fg.controls['recipientsString'].dirty || fg.controls['recipientsString'].touched),
            }" />
    </div>
    <div class="action-setting">
        <div class="action-setting-title">
            {{ "commonActions.sendEmailAction.subject" | labelsProvider }}
        </div>
        <input
            class="action-setting-input"
            formControlName="subject"
            type="text"
            placeholder="Enter subject"
            [ngClass]="{
                'input-form-invalid': fg.controls['subject'].invalid && (fg.controls['subject'].dirty || fg.controls['subject'].touched),
            }" />
    </div>
    <div class="action-setting">
        <div class="action-setting-title">
            {{ "commonActions.sendEmailAction.body" | labelsProvider }}
        </div>
        <textarea
            type="text"
            formControlName="bodyText"
            placeholder="Enter text"
            [ngClass]="{
                'input-form-invalid': fg.controls['bodyText'].invalid && (fg.controls['bodyText'].dirty || fg.controls['bodyText'].touched),
            }">
        </textarea>
    </div>

    <div class="action-setting">
        <div class="action-setting-title">
            Available Labels
            <img
                class="info"
                src="assets/images/notifications/info.svg"
                alt="info"
                matTooltip="Text labels will be replaced with the relevant values in the email body and subject"
                matTooltipPosition="above"
                matTooltipClass="tooltip-container" />
        </div>
        <div class="textarea">
            <div *ngFor="let placeholder of supportedEmailPlaceholders">
                <p>
                    <kbd>{{ placeholder.label }}</kbd>
                    {{ placeholder.description }}
                </p>
            </div>
        </div>
    </div>
</div>
